class Tabs extends HTMLElement {
    constructor() {
      super();
      this.toggles = [...this.querySelectorAll('[data-toggle]')];
      this.collapsibles = [...this.querySelectorAll('[data-content]')];
    //   this.collapsiblesMobile = [...this.querySelectorAll('[data-tab-menu]')];
    //   this.togglesMobile = [...this.querySelectorAll('[data-tab-selector]')];
    //   this.titleOption = [...this.querySelectorAll('[data-title-option]')];
    }
  
    connectedCallback() {
        console.log(this.collapsibles)
      this.toggles?.forEach((btn) => {
        const id = btn.dataset.toggle;
        const collapsible = this.collapsibles.find(({ dataset }) => dataset.content === id);
        btn.addEventListener('click', () => {
          this.toggles.forEach((tab)=>{
              tab.classList.remove('active');
          })
          btn.classList.add('active');
          // btn.addEventListener('click', () => {
          //   this.toggleMenu(collapsible);
          // });
          this.collapsibles.filter(({ dataset }) => dataset.content !== id)
            .forEach((inactiveCollapsible) => {
                console.log(inactiveCollapsible)
              // eslint-disable-next-line no-param-reassign
              inactiveCollapsible.classList.add('!hidden');
            });
            collapsible.classList.remove('!hidden');
        });
  
      });
  
    
  
      //DEEP LINK
    //   let url = window.location.href;
    //   if (url.indexOf("#") > 0){
  
    //     const activeTab = url.substring(url.indexOf("#") + 1);
    //     const activecollapsible = this.toggles.find(({ dataset }) => dataset.toggle === activeTab.toLowerCase());
  
    //     if(activecollapsible){
    //       activecollapsible.click();
    //     }
    //   }
    }
   
  }
  customElements.define('tab-content', Tabs);